import React from 'react';
import { SectionInstance } from '../types';
import InlineEditText from '../InlineEditText';
import { renderSbIcon } from '../IconPickerField';
import { sfCtaText, sfCtaUrl, sfHeadline, sfSub } from './sectionHelpers';

interface Props {
  section: SectionInstance;
}

const HeroCards: React.FC<Props> = ({ section }) => {
  const c = section.controls;
  const cards = (c.cards || [
    { title: 'Revenue', value: '+127%', icon: '📈' },
    { title: 'Clients', value: '2,400+', icon: '👥' },
    { title: 'Uptime', value: '99.9%', icon: '⚡' },
  ]) as Array<{ title: string; value: string; icon: string }>;

  const rotations = [-4, 2, -2, 5, -3];

  return (
    <header
      className="sb-render sb-render-hero-cards"
      style={{
        position: 'relative',
        overflow: 'hidden',
        padding: '100px 24px 140px',
        background: 'linear-gradient(135deg, var(--brand-primary, #1a365d) 0%, var(--brand-secondary, #2563eb) 60%, #7c3aed 100%)',
        color: '#fff',
        textAlign: 'center',
      }}
    >
      {/* Background mesh */}
      <div style={{
        position: 'absolute', inset: 0, pointerEvents: 'none',
        background: 'radial-gradient(ellipse at 30% 50%, rgba(255,255,255,0.07) 0%, transparent 60%), radial-gradient(ellipse at 70% 50%, rgba(255,255,255,0.05) 0%, transparent 60%)',
      }} />

      <div style={{ position: 'relative', zIndex: 1, maxWidth: 700, margin: '0 auto', marginBottom: 64 }}>
        <InlineEditText
          tag="h1"
          controlKey="headline"
          style={{ fontSize: '3.5rem', lineHeight: 1.1, fontWeight: 800, marginBottom: 20, letterSpacing: '-0.025em', color: '#fff' }}
        >
          {sfHeadline(c, 'The Platform That Delivers')}
        </InlineEditText>
        <InlineEditText
          tag="p"
          controlKey="subheadline"
          style={{ fontSize: '1.2rem', opacity: 0.85, marginBottom: 36, maxWidth: 520, margin: '0 auto 36px' }}
        >
          {sfSub(c, 'Trusted by thousands of businesses worldwide.')}
        </InlineEditText>
        <a
          href={sfCtaUrl(c)}
          className="sb-cta-btn"
          style={{
            display: 'inline-block',
            padding: '15px 40px',
            borderRadius: 'var(--brand-btn-radius, 6px)',
            background: '#fff',
            color: 'var(--brand-primary, #1a365d)',
            fontWeight: 700,
            textDecoration: 'none',
            fontSize: '1rem',
            boxShadow: '0 8px 30px rgba(0,0,0,0.25)',
          }}
        >
          <InlineEditText tag="span" controlKey="cta_text">
            {sfCtaText(c, 'Start Free Trial')}
          </InlineEditText>
        </a>
      </div>

      {/* Floating cards */}
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'center',
        gap: 20,
        position: 'relative',
        zIndex: 1,
        maxWidth: 900,
        margin: '0 auto',
      }}>
        {cards.map((card, i) => (
          <div
            key={i}
            style={{
              background: 'rgba(255,255,255,0.12)',
              backdropFilter: 'blur(12px)',
              border: '1px solid rgba(255,255,255,0.2)',
              borderRadius: 'var(--brand-card-radius, 16px)',
              padding: '24px 32px',
              minWidth: 160,
              transform: `rotate(${rotations[i % rotations.length]}deg)`,
              boxShadow: '0 20px 40px rgba(0,0,0,0.2)',
              textAlign: 'center',
              color: '#fff',
              transition: 'transform 0.3s',
            }}
          >
            <div style={{ fontSize: '2rem', marginBottom: 8 }}>{renderSbIcon(card.icon, 32)}</div>
            <div style={{ fontSize: '1.75rem', fontWeight: 800, marginBottom: 4, lineHeight: 1 }}>{card.value}</div>
            <div style={{ fontSize: '0.875rem', opacity: 0.75, fontWeight: 500 }}>{card.title}</div>
          </div>
        ))}
      </div>
    </header>
  );
};

export default HeroCards;
